(() => {
  let swiper = null;

  const initSlider = (wrapper) => {
    const sliderEl = wrapper.querySelector(".js-featured-products-slider");
    if (!sliderEl) return;

    const productsPerRowMobile = Number(
      sliderEl.dataset.productsPerRowMobile || 1
    );

    // const cards = wrapper.querySelectorAll(".featured-products__item");
    // const images = wrapper.querySelectorAll(".featured-products__image");
    // const detailedButton = wrapper.querySelector(".featured-products__button");

    const prevBtn = sliderEl.querySelector(
      ".featured-products__navigation-button-prev"
    );
    const nextBtn = sliderEl.querySelector(
      ".featured-products__navigation-button-next"
    );

    swiper = new Swiper(sliderEl, {
      speed: 800,
      loop: false,
      watchSlideProgress: true,
      allowTouchMove: true,
      touchEventsTarget: "container ",
      mousewheel: {
        forceToAxis: true,
      },
      pagination: {
        el: ".featured-products__navigation .swiper-pagination",
        type: "progressbar",
      },
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
        disabledClass: "swiper-button-disabled",
      },
      breakpoints: {
        0: {
          slidesPerView: productsPerRowMobile,
          spaceBetween: 2,
        },
        576: {
          slidesPerView: productsPerRowMobile,
          spaceBetween: 202,
        },
        750: {
          slidesPerView: 3,
          spaceBetween: 202,
        },
        1160: {
          slidesPerView: 3,
          spaceBetween: 0,
        },
        1360: {
          slidesPerView: 4,
          spaceBetween: 0,
        },
        1600: {
          slidesPerView: 5,
          spaceBetween: 0,
        },
      },
      // on: {
      //   slideChange: function () {
      //     const activeSlide = this.slides[this.activeIndex];
      //     if (!activeSlide) return;
      //     const itemId = activeSlide.dataset.itemId;
      //     const url = activeSlide.dataset.productUrl;

      //     toggleCard(activeSlide, itemId, cards, images, detailedButton, url);
      //   },
      // },
    });
  };

  // const destroySlider = (sliderEl) => {
  //   if (!sliderEl) return;
  //   const sliderWrapper = sliderEl.querySelector(".swiper-wrapper");
  //   const slides = sliderEl.querySelectorAll(".swiper-slide");

  //   if (sliderEl?.swiper) sliderEl.swiper.destroy();
  //   if (sliderWrapper) sliderWrapper.removeAttribute("style");

  //   slides.forEach((slide) => {
  //     slide.removeAttribute("style");
  //   });
  // };

  const updateSpaceBetween = (sliderEl) => {
    if (!sliderEl || !swiper) return;

    const containerWidth = sliderEl.clientWidth;
    const computedStyle = window.getComputedStyle(sliderEl);
    const paddingInline = parseInt(computedStyle.paddingLeft);

    const SLIDE_WIDTH = 148;
    const SLIDES_PER_VIEW = 3;
    const MAX_SPACE = 674;
    const MIN_SPACE = 70;

    if (
      containerWidth >= 300 &&
      window.innerWidth >= 576 &&
      window.innerWidth < 1160
    ) {
      let space =
        (containerWidth - SLIDES_PER_VIEW * SLIDE_WIDTH) /
          (SLIDES_PER_VIEW - 1) -
        paddingInline;

      space = Math.max(MIN_SPACE, Math.min(space, MAX_SPACE));

      swiper.params.spaceBetween = space;

      swiper.update();
    }
  };

  const overlapAnimation = () => {
    document.querySelectorAll(".sticky-section").forEach((block) => {
      const box = block.closest("section");
      const stickyEffect = block.querySelector("[data-sticky-effect]");

      if (!stickyEffect) return;

      const normalElement = box.previousElementSibling;
      if (!normalElement) return;

      const nextElement = box.nextElementSibling;
      const nextElementNext = nextElement && nextElement.nextElementSibling;

      setTimeout(() => {
        const viewportHeight = window.innerHeight;
        const sectionHeight = normalElement.getBoundingClientRect().height;

        let scrollTop = 0;

        if (sectionHeight >= viewportHeight) {
          scrollTop = viewportHeight - sectionHeight;
        } else {
          scrollTop = 0;
        }

        normalElement.style.setProperty("--viewport-height", `${scrollTop}px`);
      }, 100);

      normalElement.classList.add("sticky-active");
      nextElement && nextElement.classList.add("background", "relative-z1");
      nextElementNext &&
        nextElementNext.classList.add("background", "relative-z1");

      let isSticky = false;

      window.addEventListener("scroll", function () {
        const stickyTop = normalElement.getBoundingClientRect().top;
        const normalElementBottom = box.getBoundingClientRect().top;

        if (stickyTop <= 0 && !isSticky) {
          normalElement.classList.add("sticky-active");
          isSticky = true;
        }

        if (normalElementBottom <= 0 && isSticky) {
          normalElement.classList.remove("sticky-active");
          isSticky = false;
        }
      });
    });
  };

  const addProductCardColorScheme = (wrapper) => {
    const productCards = wrapper.querySelectorAll(".product-card");
    const schemeOnHover = wrapper.getAttribute("data-scheme-on-hover");
    const colorClass = `color-${schemeOnHover}`;

    if (!schemeOnHover) return;

    productCards.forEach((element) => {
      element.addEventListener("mouseenter", () => {
        element.classList.add(colorClass);
      });

      element.addEventListener("mouseleave", () => {
        element.classList.remove(colorClass);
      });
    });
  };

  const addMobileColorScheme = (wrapper) => {
    const scheme = wrapper.getAttribute("data-scheme-on-mobile");

    if (!scheme) return;

    const mobileClass = `color-${scheme}`;
    const isMobile = window.innerWidth <= 1160;

    if (!wrapper._originalColors) {
      wrapper._originalColors = [...wrapper.classList].filter((c) =>
        c.startsWith("color-")
      );
    }

    const currentColorClasses = [...wrapper.classList].filter((c) =>
      c.startsWith("color-")
    );

    const hasMobileClass = currentColorClasses.includes(mobileClass);
    const isOnlyMobileClass =
      currentColorClasses.length === 1 && hasMobileClass;

    if (isMobile) {
      if (isOnlyMobileClass) return;

      wrapper.classList.forEach((c) => {
        if (c.startsWith("color-")) wrapper.classList.remove(c);
      });

      wrapper.classList.add(mobileClass);
    } else {
      const isSameAsOriginal =
        currentColorClasses.length === wrapper._originalColors.length &&
        currentColorClasses.every((c) => wrapper._originalColors.includes(c));

      if (isSameAsOriginal) return;

      wrapper.classList.forEach((c) => {
        if (c.startsWith("color-")) wrapper.classList.remove(c);
      });

      wrapper._originalColors.forEach((c) => wrapper.classList.add(c));
    }
  };

  const initSection = (section) => {
    if (!section || !section?.classList.contains("featured-products-section")) {
      return;
    }

    // init animation
    overlapAnimation();

    const wrapper = section.querySelector(".featured-products");

    if (!wrapper) return;

    // add color scheme to product cards on hover and mobile breakpoint switching
    addProductCardColorScheme(wrapper);
    addMobileColorScheme(wrapper);
    window.addEventListener("resize", () => addMobileColorScheme(wrapper));

    // init slider
    const sliderEl = wrapper.querySelector(".js-featured-products-slider");

    if (sliderEl) {
      if (sliderEl?.swiper) return;

      initSlider(wrapper);
      updateSpaceBetween(sliderEl);
      window.addEventListener("resize", () => updateSpaceBetween(sliderEl));
    }
  };

  const featuredProducts = document.querySelectorAll(
    ".featured-products-section"
  );

  featuredProducts.forEach((featuredProduct) => {
    initSection(featuredProduct);
  });

  document.addEventListener("shopify:section:load", function (event) {
    initSection(event.target);
  });
})();
